import { EEventType } from "./EEventType";

export function DispatchEvent<TPayload>(
    eventType: EEventType,
    payload?: TPayload
) {
    var eventDetail = payload !== undefined ? { detail: payload } : {};
    var type = EEventType[eventType];
    var event = new CustomEvent<TPayload>(type, eventDetail);
    document.dispatchEvent(event);

    const existingLastDispatchedEvent = lastDispatchedEvents.find(
        (record) => record.type == type
    );

    if (existingLastDispatchedEvent === undefined) {
        lastDispatchedEvents.push({
            type,
            eventDetail,
        });
    } else {
        existingLastDispatchedEvent.eventDetail = eventDetail;
    }
}

const lastDispatchedEvents: { type: string; eventDetail: any }[] = [];

export function SubscribeToEvent<TPayload>(
    eventType: EEventType,
    handler: (payload: TPayload) => void
) {
    const EventHandler = (event: Event) => {
        const payload = (event as any).detail;
        handler(payload);
    };

    document.addEventListener(EEventType[eventType], EventHandler);

    DispatchLastEvent<TPayload>(eventType, handler);

    return () =>
        document.removeEventListener(EEventType[eventType], EventHandler);
}

function DispatchLastEvent<TPayload>(
    eventType: EEventType,
    handler: (payload: TPayload) => void
) {
    var type = EEventType[eventType];

    const existingLastDispatchedEvent = lastDispatchedEvents.find(
        (record) => record.type == type
    );

    if (existingLastDispatchedEvent !== undefined) {
        handler(existingLastDispatchedEvent.eventDetail.detail);
    }
}
